import { useState } from 'react';

import { Box } from '@twilio-paste/core/box';
import { Button } from '@twilio-paste/core/button';
import { Input } from '@twilio-paste/core/input';
import { HideIcon } from '@twilio-paste/icons/esm/HideIcon';
import { ShowIcon } from '@twilio-paste/icons/esm/ShowIcon';

import { CopyButton } from '../../../common/CopyButton';

interface AppSecretProps {
  apiKey: string;
}

export function AppSecret({ apiKey }: AppSecretProps) {
  const [showSecrets, setShowSecrets] = useState(false);

  const toggleSecrets = () => {
    setShowSecrets(toggle => !toggle);
  };

  return (
    <Box display="flex" columnGap="space20" width="100%">
      <Input type={showSecrets ? 'text' : 'password'} value={apiKey} readOnly />
      <Button
        variant="secondary"
        onClick={toggleSecrets}
        title={showSecrets ? 'Hide Api Key' : 'Show Api key'}
        disabled={!apiKey}
      >
        {showSecrets ? <HideIcon decorative /> : <ShowIcon decorative />}
      </Button>
      <CopyButton title="Copy Api Key" value={apiKey} disabled={!apiKey} />
    </Box>
  );
}
